module.exports = __webpack_public_path__ + "media/src/website/images/locations/burghausen/burghausen_01-d8916a8f42e54d98470a8b78ea300cda.jpg";